import { Capacitor } from '@capacitor/core';

/**
 * Get the appropriate redirect URL based on the platform
 * @param {string} path - The path to redirect to (e.g., '/reset-password')
 * @returns {string} The full redirect URL
 */
export const getRedirectUrl = (path) => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  // Always use HTTPS URL for Universal Links (iOS) and App Links (Android)
  // This ensures the link in the email is https://app.lifecoachassist.ai/...
  // which the OS will intercept and open the app.
  return `https://app.lifecoachassist.ai${normalizedPath}`;
};

/**
 * Get app URL for various auth redirects
 */
export const getAppUrl = () => {
  if (Capacitor.isNativePlatform()) {
    return 'lifecoachassist://';
  } else {
    return 'https://app.lifecoachassist.ai';
  }
};

export default { getRedirectUrl, getAppUrl };
